import { render, staticRenderFns } from "./HTMLAgreement.vue?vue&type=template&id=baaaa56e"
import script from "./HTMLAgreement.vue?vue&type=script&lang=js"
export * from "./HTMLAgreement.vue?vue&type=script&lang=js"
import style0 from "./HTMLAgreement.vue?vue&type=style&index=0&id=baaaa56e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports